import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useAppSelector } from '../../app/indexReducer';
import { getFeatureReleaseUrl } from '../../app/utils/urls';
import { selectHasBetaAdminAccessScope, selectHasSlowRolloutScope } from '../../app/auth/ScopeSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ManageReleaseSettingsLink() {
  const hasSlowRolloutScope = useAppSelector(selectHasSlowRolloutScope);
  const hasBetaAdminAccessScope = useAppSelector(selectHasBetaAdminAccessScope);
  return hasSlowRolloutScope ? /*#__PURE__*/_jsx(Link, {
    external: true,
    href: getFeatureReleaseUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.header.manageReleaseSettingsAndNotifications"
    })
  }) : hasBetaAdminAccessScope ? /*#__PURE__*/_jsx(Link, {
    external: true,
    href: getFeatureReleaseUrl(),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.header.manageNotifications"
    })
  }) : null;
}